import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { iCustomerResult } from 'src/app/helpers/Interfaces/customer';
import {
  iPaginationRequest,
  iPaginationResult,
} from 'src/app/helpers/Interfaces/pagination';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private _getCustomerByUserId = `${environment.base_url}/api/Customer/GetByUserId`;
  private _getAllCustomers = `${environment.base_url}/api/Customer/GetAll`;
  private _addCustomer = `${environment.base_url}/api/Customer/Add`;
  private _updateCustomer = `${environment.base_url}/api/Customer/Update`;
  private _removeCustomer = `${environment.base_url}/api/Customer/Remove`;
  private _permanentDelete = `${environment.base_url}/api/Customer/PermanentDelete`;
  constructor(private _http: HttpClient) {}

  GetCustomerByUserId(userId: string) {
    return this._http.get(`${this._getCustomerByUserId}?userId=${userId}`, {
      responseType: 'json',
    });
  }

  GetAllCustomers(payload: iPaginationRequest) {
    if (!payload.sortingParams) payload.sortingParams = {};
    return this._http.post<iPaginationResult<iCustomerResult>>(
      this._getAllCustomers,
      payload,
      {
        responseType: 'json',
      }
    );
  }
  // GetAllCustomers() {
  //   return this._http.get<any[]>(this._getAllCustomers, {
  //     responseType: 'json',
  //   });
  // }
  private shapePayload(data: any) {
    const {
      id,
      name,
      contactPersonEmail,
      contactPersonName,
      contactPersonPhone,
      contactPersonWhatsapp,
      organizationId,
      webUrl,
      userId,
    } = data;
    const payload = new FormData();
    payload.set('Name', name);
    payload.set('ContactPersonName', contactPersonName);
    payload.set('ContactPersonEmail', contactPersonEmail);
    payload.set('ContactPersonPhone', contactPersonPhone);
    payload.set('ContactPersonWhatsapp', contactPersonWhatsapp);
    payload.set('OrganizationId', organizationId);
    payload.set('WebUrl', webUrl);
    payload.set('UserId', userId);
    if (id) {
      payload.set('Id', id);
    }

    return payload;
  }
  AddCustomer(payload: any) {
    return this._http.post<any>(this._addCustomer, this.shapePayload(payload), {
      responseType: 'json',
    });
  }

  UpdateCustomer(data: any, logo?: any) {
    const payload = this.shapePayload(data);
    if (logo) {
      payload.set('CompanyLogo', logo);
    }
    return this._http.put<any>(this._updateCustomer, payload, {
      responseType: 'json',
    });
  }
  DeleteCustomer(id: any) {
    return this._http.delete(`${this._removeCustomer}?id=${id}`);
  }
  permanentDelete(id: string) {
    return this._http.delete(`${this._permanentDelete}?Id=${id}`);
  }
}
